var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerLeft1"}},[_c('div',{staticClass:"bg-color-black school-gif"},[_c('img',{attrs:{"src":_vm.etype === 3 ? _vm.schoolLoadImg : _vm.platformLoadImg,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }